import styled from "styled-components";
import Drawer from "@material-ui/core/Drawer";
import { ssm } from "../../../AppTheme.styled";

const StyledDrawer = styled(Drawer)`
  .MuiPaper-root {
    padding: 70px 0 16px;
    box-shadow: 0px 4px 6px -1px rgba(26, 32, 44, 0.1),
      0px 2px 4px -1px rgba(26, 32, 44, 0.06);
  }

  .MuiBackdrop-root {
    background-color: rgb(0, 0, 0, 0.2);
  }

  ${ssm} {
    .MuiPaper-root {
      padding: 70px 16px 16px;
    }
  }
`;

export default StyledDrawer;
